// A quote/deal line's price is PER-UNIT and quantity is the sellable count
// (CONTEXT.md "Line price (per-unit) & Quantity"). A Shopify draft lists at the
// per-unit price with inventory = quantity, so a qty>1 draft sells for
// price × quantity in total.
//
// perUnitLineTotal surfaces that arithmetic on the Drafts page so the approver
// sees it at sign-off — the one place a whole-lot total wrongly entered in the
// per-unit field (a legacy re-draft, or a fat-fingered bundle price) can be
// caught before the draft is activated. Returns null when there is nothing to
// confirm (single unit, or not yet priced).
export function perUnitLineTotal(draft) {
  const qty = Number(draft?.quantity) || 1
  const unit = Number(draft?.sellPrice) || 0
  if (qty <= 1 || unit <= 0) return null
  return { qty, unit, total: Math.round(unit * qty * 100) / 100 }
}
